import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, Avatar, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

const USHouseOfRepElectionsCommentsReplyPage = () => {
    const [comment, setComment] = useState(null);
    const history = useHistory();
    const [title, setTitle] = useState('');
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState('');
    const [replyText, setReplyText] = useState("");
    const [replyChain, setReplyChain] = useState([]);

    const { id, commentId } = useParams();
    const [poll, setPoll] = useState(null);

    const [openDialog, setOpenDialog] = useState(false);
    const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
    const [activePostId, setActivePostId] = useState(null);

    const [replyOpen, setReplyOpen] = useState(false);
    const [activeCommentId, setActiveCommentId] = useState(null);

    const [undoDialogOpen, setUndoDialogOpen] = useState(false);
    const [pendingUndoCaseId, setPendingUndoCaseId] = useState(null);
    const [pendingUndoBill, setPendingUndoBill] = useState(null);

    const [openVotersDialog, setOpenVotersDialog] = useState(false);
    const [activeVoters, setActiveVoters] = useState([]);
    const [dialogTitle, setDialogTitle] = useState("");
    const [voteRationale, setVoteRationale] = useState(null);

    const [loggedInUser, setLoggedInUser] = useState(null);

    const [votersDialogOpen, setVotersDialogOpen] = useState(false);
    const [selectedOptionVoters, setSelectedOptionVoters] = useState([]);

    useEffect(() => {
            axios.get("/user/me")
                .then(res => setLoggedInUser(res.data))
                .catch(() => setLoggedInUser(null));
        }, []);

    // Fetch poll info
    useEffect(() => {
        axios.get(`/elections/USHouseOfRep/singlePoll/${id}`)
            .then(res => setPoll(res.data))
            .catch(err => console.error("Error loading poll", err));
    }, [id]);

    /*useEffect(() => {
        const fetchContext = async () => {
        try {
            const res = await axios.get(
            `/elections/USHouseOfRep/${id}/commentReplies/${commentId}`
            );
            setReplyChain(res.data.chain);
            setComment(res.data.current);
        } catch (err) {
            console.error("Error loading comment context", err);
        }
        };

        fetchContext();
    }, [id, commentId]);*/
    const location = useLocation();
const source = location.state?.source;


const [isLoadingReplies, setIsLoadingReplies] = useState(false);


// Pagination stored in refs — never captured stale in observer closures
const cursorRef = useRef(null);
const hasMoreRef = useRef(true);
const isFetchingRef = useRef(false);
const abortRef = useRef(null);


// ── Stable navigation callbacks — safe to pass to React.memo children ──────
const handleNavigate = useCallback((targetId) => {
 history.push(`/Government/Elections/USHouseOfRepElections/${id}/comments/${targetId}`, { source });
}, [history, id, source]);


// ── Core fetch — reads cursor from ref, never from a stale closure ─────────
 const fetchReplies = useCallback(async (overrideCursor) => {
   if (isFetchingRef.current || !hasMoreRef.current) return;


   abortRef.current?.abort();
   abortRef.current = new AbortController();
   isFetchingRef.current = true;
   setIsLoadingReplies(true);


   // undefined means "use whatever cursorRef holds right now"
   const cursorToUse = overrideCursor !== undefined ? overrideCursor : cursorRef.current;


   try {
     const res = await axios.get(
       `/elections/USHouseOfRep/${id}/commentReplies/${commentId}`,
       {
         params: { cursor: cursorToUse ?? undefined, limit: 10 },
         signal: abortRef.current.signal,
       }
     );


     if (!cursorToUse) {
       // Initial load
       setReplyChain(res.data.chain);
       setComment(res.data.current);
     } else {
       // Append page
       setComment(prev => prev
         ? { ...prev, replies: [...prev.replies, ...res.data.current.replies] }
         : prev
       );
     }


     // Write to refs synchronously — observer always reads current values
     cursorRef.current = res.data.nextCursor;
     hasMoreRef.current = res.data.hasMore;


   } catch (err) {
     if (axios.isCancel(err) || err.name === "CanceledError") return;
     console.error("Fetch replies failed", err);
   } finally {
     isFetchingRef.current = false;
     setIsLoadingReplies(false);
   }
 }, [id, commentId]);


 // ── Reset + initial load whenever route params change ─────────────────────
 useEffect(() => {
   cursorRef.current = null;
   hasMoreRef.current = true;
   isFetchingRef.current = false;
   setComment(null);
   setReplyChain([]);
   fetchReplies(null);
   return () => abortRef.current?.abort();
 }, [id, commentId, fetchReplies]);


 // ── IntersectionObserver on a SEPARATE sentinel div, not the last card ─────
 // This is what makes click + observer mutually exclusive at the DOM level.
 const observerRef = useRef();
 const sentinelRef = useCallback(node => {
   if (observerRef.current) observerRef.current.disconnect();
   if (!node) return;
   observerRef.current = new IntersectionObserver(entries => {
     if (entries[0].isIntersecting && hasMoreRef.current && !isFetchingRef.current) {
       fetchReplies(undefined); // reads cursorRef.current internally
     }
   }, { rootMargin: "300px" });
   observerRef.current.observe(node);
 }, [fetchReplies]);


    const updateReplyChainRecursive = (nodes = [], id, updates) => {
      let changed = false;

      const next = nodes.map((n) => {
        if (n._id === id) {
          changed = true;
          return { ...n, ...updates };
        }

        const updatedReplies = updateReplyChainRecursive(n.replies, id, updates);
        if (updatedReplies !== n.replies) {
          changed = true;
          return { ...n, replies: updatedReplies };
        }

        return n;
      });

      return changed ? next : nodes;
    };

    const updateReplyRecursive = (replies = [], replyId, updates) => {
      return replies.map((r) => {
        if (r._id === replyId) {
          return { ...r, ...updates };
        }

        return {
          ...r,
          replies: updateReplyRecursive(r.replies, replyId, updates),
        };
      });
    };

    const toggleReplyVote = async (replyId) => {
      try {
        const res = await axios.post(
          `/elections/USHouseOfRep/${id}/commentReplies/${replyId}/upvote`
        );

        const { replyUpvotes, replyVoted } = res.data;

        setComment((prev) => {
          if (!prev) return prev;

          // Case A: current focused comment is the reply
          if (prev._id === replyId) {
            return {
              ...prev,
              replyUpvotes,
              replyVoted,
            };
          }

          // Case B: reply exists somewhere in the chain
          return {
            ...prev,
            replies: updateReplyRecursive(prev.replies, replyId, {
              replyUpvotes,
              replyVoted,
            }),
          };
        });

        setReplyChain((prev) =>
          updateReplyChainRecursive(prev, replyId, {
            replyUpvotes,
            replyVoted,
          })
        );
      } catch (err) {
        console.error("Reply vote error", err);
      }
    };

    const handleReplySubmit = async () => {
      if (!replyText.trim()) return;

      try {
        const res = await axios.post(`/elections/USHouseOfRepComments/${comment._id}/reply`, {
          text: replyText,
        });

        const commentRes = await axios.get(
          `/elections/USHouseOfRep/${id}/commentReplies/${commentId}`
        );
        setReplyChain(commentRes.data.chain);
        setComment(commentRes.data.current);
        setReplyText("");
      } catch (err) {
        console.error("Reply error", err);
      }
    };
    if (!comment) return <Typography>Loading...</Typography>;

    const CommentCard = ({ comment }) => (
        <Box
            p={2} // padding inside box
            my={2} // vertical margin between posts
            //onClick={() => history.push(`/Government/Elections/USHouseOfRepElections/${id}/comments/${comment._id}`)} 
            onClick={() => handleNavigate(comment._id)}
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            sx={{
            position: "relative",
            maxWidth: 900, // limit width
            mx: "auto", // center horizontally
            my: 2, // vertical spacing between each post
            cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
            }}
        >
            <Box display="flex" alignItems="flex-start" gap={1}>
            <Avatar
                src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
                onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{ 
                                    width: 62, 
                                    height: 62,
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#d9e4f0",
                                    }, 
                                    }}
            />
            <Box>
                <Typography variant="subtitle1" fontWeight="bold"
                onClick={(e) => visitProfile(e, comment.author?._id)}
                                        sx={{
                                            cursor: "pointer",
                                            display: "inline-block",
                                            "&:hover": {
                                            textDecoration: "underline",
                                            textDecorationColor: "currentColor", 
                                            textUnderlineOffset: "3px",
                                            },
                                        }}
                >
                {comment.author?.first_name} {comment.author?.last_name}
                </Typography>
                <Typography variant="body2" color="text.secondary"
                onClick={(e) => visitProfile(e, comment.author?._id)}
                                        sx={{
                                            cursor: "pointer",
                                            display: "block",
                                            "&:hover": {
                                            textDecoration: "underline",
                                            textDecorationColor: "#currentColor",
                                            textUnderlineOffset: "3px",
                                            },
                                        }}
                >
                @{comment.author?.username}
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                {comment.text}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                                {`${new Date(comment.created_at).toLocaleString()}, ${
                                                    comment.replyCount ?? 0
                                                } ${comment.replyCount === 1 ? "reply" : "replies"}`}
                                            </Typography>
            </Box>
            </Box>

            <Box mt={2} display="flex" alignItems="center" gap={1}>
                                {comment.replyVoted ? (
                                    <Box
                                    sx={{
                                        position: "relative",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        "&:hover .voted-btn": {
                                            opacity: 0,
                                        },
                                        "&:hover .undo-btn": {
                                            opacity: 1,
                                            pointerEvents: "auto",
                                        },
                                    }}
                                >
                                        <Button
                                            size="small"
                                            className="voted-btn"
                                            variant="contained"
                                            color="success"
                                            disabled
                                            sx={{
                                            transition: "opacity 0.2s ease",
                                            }}
                                        >
                                        Power Voted
                                    </Button>
                                    <Button
                                            size="small"
                                            className="undo-btn"
                                            variant="contained"
                                            color="error"
                                            sx={{
                                            inset: 0,
                                            position: "absolute",
                                            transition: "opacity 0.2s ease",
                                            opacity: 0,
                                            pointerEvents: "none",
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleReplyVote(comment._id)
                                        }}
                                    >
                                            Undo
                                    </Button>
                                </Box>
                                ) : (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReplyVote(comment._id)}
                                    }
                                    >
                                        ▲ Power Vote
                                    </Button>
                                )}
                                <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                        </Box>
        </Box>
        );

    if (!poll) return null;
    
    const totalVotes = poll?.options.reduce((sum, o) => sum + o.votes, 0);

    const sortedResults = [...poll?.options]
        .sort((a, b) => b.votes - a.votes)
        .map(opt => ({
            ...opt,
            percentage: totalVotes
                ? Math.round((opt.votes / totalVotes) * 100)
                : 0,
    }));

    const votedOption = poll?.options.find(o => o.id === poll.userVote);
    const votedOptionLabel = votedOption?.label;

    const undoVote = async () => {
        try {
            await axios.post(`/elections/USHouseOfRep/${poll._id}/undoVote`);
            const res = await axios.get(`/elections/USHouseOfRep/singlePoll/${poll._id}`);
            setPoll(res.data);

            const commentRes = await axios.get(
                `/elections/USHouseOfRep/${id}/commentReplies/${commentId}`
            );
            setReplyChain(commentRes.data.chain);
            setComment(commentRes.data.current);
        } catch (err) {
            console.error("Undo vote failed", err);
        }
     };

    const showVotersForOption = (optionId) => {
        const voters = poll.votes.filter(v => v.optionId === optionId);
        setSelectedOptionVoters(voters);
        setVotersDialogOpen(true);
    };

    const VoteDialog = ({ open, onClose, options, pollId, onVoted }) => {
        const [selected, setSelected] = useState("");
        const [comment, setComment] = useState("");

        const handleSubmit = async () => {
            if (!selected || !comment.trim()) return;

            const commentRes = await axios.post(
                `/elections/USHouseOfRep/${pollId}/comment`,
                { text: comment }
            );

            const commentResId = commentRes.data._id; 
            //setComments(prev => [commentRes.data, ...prev]);
            //const res = await axios.get(`/elections/USHouseOfRep/${pollId}/comments`);
            //setComments(res.data);
            const res = await axios.get(
                `/elections/USHouseOfRep/${id}/commentReplies/${commentResId}`
            );
            setReplyChain(res.data.chain);
            setComment(res.data.current);

            const commentId = commentRes.data._id; 

            await axios.post(
                `/elections/USHouseOfRep/${pollId}/vote`,
                { optionId: selected, commentId }
            );

            const pollRes = await axios.get(`/elections/USHouseOfRep/singlePoll/${pollId}`);

            onVoted(pollRes.data);

            

            onClose();
        };

        return (
            <Dialog 
                open={open} 
                onClose={onClose} 
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle>Cast Your Power Vote</DialogTitle>

                <DialogContent>
                    <RadioGroup
                        value={selected}
                        onChange={(e) => setSelected(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {options.map(opt => (
                            <FormControlLabel
                                key={opt.id}
                                value={opt.id}
                                control={<Radio />}
                                label={opt.label}
                            />
                        ))}
                    </RadioGroup>

                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        placeholder="Explain your power vote (required)"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                    />
                </DialogContent>

                <DialogActions>
                    {/*<Button onClick={onClose}>Cancel</Button>*/}
                    <Button 
                        onClick={(e) => {
                            e.stopPropagation();
                            onClose();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="outlined"
                        disabled={!comment || !selected}
                        //onClick={handleSubmit}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleSubmit();
                        }}
                    >
                        Submit Power Vote
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    const ResultRow = ({ item }) => (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1}
            borderBottom="1px solid #eee"
        >
            <Box>
                <Typography fontWeight={500}>{item.label}</Typography>
                {/* CLICKABLE VOTE COUNT */}
                <Typography
                    variant="caption"
                    color="primary"
                    //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                    //onClick={() => onVotesClick(item.id)}
                    //onClick={(e) => {
                    //    e.stopPropagation();
                    //    onVotesClick(item.id);
                    //}}
                >
                    {item.votes} Power Votes
                </Typography>
            </Box>

            <Typography fontWeight={500}>
                {item.percentage}%
            </Typography>
        </Box>
    );

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const navItems = [
        {
            label: "U.S. House of Representatives",
            path: "/Government/Elections/USHouseOfRepresentativesElections",
            matchPaths: [
                "/Government/Elections/USHouseOfRepresentativesElections",
                "/Government/Elections/USHouseOfRepElections"
            ]
        },
        {
            label: "U.S. Senate",
            path: "/Government/Elections/USSenateElections",
            matchPaths: ["/Government/Elections/USSenateElections"]
        },
        {
            label: "State Governors",
            path: "/Government/Elections/GubernatorialElections",
            matchPaths: ["/Government/Elections/GubernatorialElections"]
        },
        {
            label: "State Legislatures",
            path: "/Government/Elections/StateLegislatureElections",
            matchPaths: ["/Government/Elections/StateLegislatureElections"]
        },
        {
            label: "Statewide Offices",
            path: "/Government/Elections/StatewideOfficesElections",
            matchPaths: ["/Government/Elections/StatewideOfficesElections"]
        }
    ];
    //const location = useLocation();

    const isActive = (item) => {
        return item.matchPaths.some((match) =>
            location.pathname.startsWith(match)
        );
        };

        const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
            borderColor: "black",
            color: "black",
            backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };
    return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                      <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/Government/Elections/USHouseOfRepresentativesElections')}
                   >
                       U.S. House of Representatives
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                   >
                       U.S. Senate
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/Government/Elections/GubernatorialElections')}
                   >
                       State Governors
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                   >
                       State Legislatures
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                   >
                       Statewide Offices
                   </Button>

        </Box>*/}
        <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: "#FFFDF8",
                    py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                >
                    {navItems.map((item) => (
                    <Button
                        key={item.path}
                        variant="outlined"
                        sx={getButtonStyles(item)}
                        onClick={() => history.push(item.path)}
                    >
                        {item.label}
                    </Button>
                    ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
        {/* State Gubernatorial Election Display */}
              <Box 
                    p={2} // padding inside box
                    my={2} // vertical margin between posts
                    border="1px solid #ccc" // light grey border
                    borderRadius="8px" // rounded corners
                    onClick={() => history.push(`/Government/Elections/USHouseOfRepElections/${id}/comments`)}
                    sx={{ 
                        position: "relative", 
                        maxWidth: 900, // limit width 
                        mx: "auto", // center horizontally
                        my: 2, // vertical spacing between each post
                        cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#f9f9f9"
                            }
                    }}
              >
                    <Typography 
                        fontWeight="bold"
                        sx={{
                            wordBreak: "break-word",
                            pr: "140px",
                            mb: 1
                        }}
                    >
                        {poll.title}
                    </Typography>

                    {/* Centered Vote Button */}
                    <Box
                        display="flex"
                        justifyContent="center"
                        mb={2}
                    >
                        {poll.userVote ? (
                            <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                <Button
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                        transition: "opacity 0.2s ease",
                                    }}
                                >
                                    Voted for {votedOptionLabel}
                                </Button>

                                <Button
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                        inset: 0, 

                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setUndoDialogOpen(true);
                                    }}
                                >
                                    Undo Vote
                                </Button>
                            </Box>
                        ) : (
                            <Button
                                variant="outlined"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setOpen(true);
                                }}
                            >
                                Power Vote
                            </Button>
                        )}
                    </Box>

                    {/* Results */}
                    <Box>
                        {sortedResults.map(item => (
                            <ResultRow 
                                key={item.id} 
                                item={item} 
                                //onVotesClick={showVotersForOption}
                            />
                        ))}
                    </Box>

                    {/* Dialog */}
                    <VoteDialog
                        open={open}
                        onClose={() => setOpen(false)}
                        options={poll.options}
                        pollId={poll._id}
                        onVoted={updatedPoll => setPoll(updatedPoll)}
                    />

                    {/* Undo Vote Dialog */}
                    <Dialog
                        open={undoDialogOpen}
                        onClose={() => setUndoDialogOpen(false)}
                        PaperProps={{
                            sx: {
                                backgroundColor: "#FFFDF8",
                                borderRadius: 3,
                                px: 2,
                                py: 1.5,
                            },
                        }}
                        >
                        <DialogTitle sx={{ fontWeight: 600 }}>
                            Undo your vote?
                        </DialogTitle>

                        <DialogContent>
                            <DialogContentText sx={{ color: "text.primary" }}>
                                This will remove your vote and the vote rationale comment associated with it.
                                This action cannot be undone.
                            </DialogContentText>
                        </DialogContent>

                        <DialogActions sx={{ pb: 2, px: 3 }}>
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setUndoDialogOpen(false)
                                }}
                                variant="outlined"
                                sx={{
                                    borderColor: "#d0cfc8",
                                    color: "text.primary",
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    await undoVote();      
                                    setUndoDialogOpen(false);
                                }}    
                                variant="contained"
                                color="error"
                                sx={{
                                    boxShadow: "none",
                                }}
                            >
                                Yes, Undo Vote
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* list of voters */}
                    {/*<Dialog
                        open={votersDialogOpen}
                        onClose={() => setVotersDialogOpen(false)}
                        fullWidth
                        maxWidth="xs"
                        PaperProps={{
                            sx: {
                                backgroundColor: "#FFFDF8",
                                borderRadius: 3,
                            },
                        }}
                    >
                        <DialogTitle sx={{ fontWeight: 600 }}>
                            Voters
                        </DialogTitle>

                        <DialogContent dividers>
                            {selectedOptionVoters.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">
                                No votes
                            </Typography>
                            ) : (
                            <List disablePadding>
                                {selectedOptionVoters.map(vote => (
                                <ListItem 
                                    key={vote.user._id} 
                                    button
                                    onClick={(e) => visitProfile(e, vote.user._id)}
                                    sx={{
                                        px: 0,
                                        borderRadius: 2,
                                        cursor: 'pointer',
                                        transition: 'background-color 0.2s',
                                        '&:hover': {
                                            backgroundColor: '#FFF2CC', // subtle highlight
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            width: '100%',
                                        }}
                                    >
                                     
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <ListItemAvatar>
                                            <Avatar src={vote.user.profileImageUrl}>
                                                {vote.user.username?.[0]}
                                            </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                                secondary={`@${vote.user.username}`}
                                            />
                                        </Box>
                                        <Typography variant="body2" color="text.secondary">
                                            Voting Power: {vote.user.tier}
                                        </Typography>
                                    </Box>
                                </ListItem>
                                ))}
                            </List>
                            )}
                        </DialogContent>

                        <DialogActions>
                        
                            <Button 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setVotersDialogOpen(false);
                                }}
                            >
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>*/}
              </Box>
        {/* Reply chain */}
        {replyChain.map((c) => (
          <CommentCard
            key={c._id}
            comment={c}
          />
        ))}
    <Box
                p={2} // padding inside box
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                }}
        >
        {/* original comment */}
        <Box display="flex" alignItems="flex-start" gap={1}>
        <Avatar
            src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
            onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{ 
                                  width: 62, 
                                  height: 62,
                                  cursor: "pointer",
                                  "&:hover": {
                                      backgroundColor: "#d9e4f0",
                                  }, 
                                  }}
        />
        <Box>
            <Typography variant="subtitle1" fontWeight="bold"
            onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
            >
            {comment.author?.first_name} {comment.author?.last_name}
            </Typography>
            <Typography variant="body2" color="text.secondary"
            onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
            >
            @{comment.author?.username}
            </Typography>
            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
            {comment.text}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                {`${new Date(comment.created_at).toLocaleString()}, ${
                    comment.replyCount
                } ${comment.replyCount === 1 ? "reply" : "replies"}`}
            </Typography>
        </Box>
        </Box>




        <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.replyVoted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReplyVote(comment._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleReplyVote(comment._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                    </Box>
    </Box>
    {/* Comment Form */}
        <Box
            p={2} // padding inside box
            my={2} // vertical margin between posts
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            sx={{
                position: "relative",
                maxWidth: 900, // limit width
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
            }}
        >
        <TextField
            fullWidth
            multiline
            rows={2}
            placeholder="Engage in intellectual discourse..."
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
        />
        <Button
            variant="outlined"
            sx={{ mt: 1 }}
            onClick={(e) => {
                e.stopPropagation();
                handleReplySubmit();
            }}
        >
            Reply
        </Button>
        </Box>
        {/* replies */}
        {comment.replies.length != 0 || hasMoreRef.current ? (
            comment.replies.map((reply, i) => {
                const isLast = i === comment.replies.length - 1;
                return (
            <Box
                p={2} // padding inside box
                key={reply._id}
                ref={isLast ? sentinelRef : null}
                //onClick={() => history.push(`/Government/Elections/USHouseOfRepElections/${id}/comments/${reply._id}`)} 
                onClick={() => handleNavigate(reply._id)}
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "#f9f9f9"
                    }
                }}
        >
            <Box display="flex" alignItems="flex-start" gap={1}>
                            <Avatar
                                src={reply.author?.profileImageUrl || '/default-avatar.jpg'}
                                alt={`${reply.author?.first_name || ''} ${reply.author?.last_name || ''}`}
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{ 
                                  width: 62, 
                                  height: 62,
                                  cursor: "pointer",
                                  "&:hover": {
                                      backgroundColor: "#d9e4f0",
                                  }, 
                                  }}
                            />
                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold"
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                                >
                                {reply.author?.first_name && reply.author?.last_name
                                    ? `${reply.author.first_name} ${reply.author.last_name}`
                                    : 'Unknown Name'}
                                </Typography>
                                <Typography variant="body2" color="text.secondary"
                                onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                                >
                                @{reply.author?.username || 'unknown'}
                                </Typography>




                                {/* Post content */}
                                <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                    {reply.text}
                                </Typography>




                                {/* Date */}
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ display: "block", mt: 0.5 }}
                                >
                                    {`${new Date(reply.created_at).toLocaleString()}, ${
                                        reply.replyCount ?? 0
                                    } ${reply.replyCount === 1 ? "reply" : "replies"}`}
                                </Typography>




                            </Box>
                        </Box>
                
                <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {reply.replyVoted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleReplyVote(reply._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(reply._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{reply.replyUpvotes} Power Votes</Typography>
                   </Box>
            </Box>
            )})
        ) : (
            <Typography></Typography>
        )}
    </div>
    );
};




export default USHouseOfRepElectionsCommentsReplyPage;
